import React, { useEffect, useState } from 'react';
import * as S from '../styles';
import EventCard from './EventCard';

export default function EventColumn({ columnKey, title, events = [], accent = '#2d6cdf', filters = [], disabledFilters = [], onFilterClick, onCardClick, blinkDelays = new Map() }) {
  const totalOrcamento = events.reduce((soma, event) => {
    const valor = Number(event?.orcamento ?? 0);
    return soma + (Number.isFinite(valor) ? valor : 0);
  }, 0);

  const totalFormatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(totalOrcamento);

  // Os 3 eventos mais atrasados da coluna alternam entre dias e meses   a cada 5s
  const [mostrarMeses, setMostrarMeses] = useState(false);
  useEffect(() => {
      const intervalo = setInterval(() => setMostrarMeses((atual) => !atual), 5000);
    return () => clearInterval(intervalo);
  }, []);
  const maisAtrasados = new Set(
    events
      .filter((event) => Number.isFinite(Number(event?.diasEvento)))
      .sort((a, b) => Number(b.diasEvento) - Number(a.diasEvento))
      .slice(0, 3),
  );

  return (
    <S.Column>
      <S.ColumnHeader accent={accent}>
        <S.ColumnTitleGroup>
          <span>{title}</span>
          <S.ColumnTotal>{totalFormatado}</S.ColumnTotal>
        </S.ColumnTitleGroup>
        <S.Counter accent={accent}>{events.length}</S.Counter>
      </S.ColumnHeader>

      {filters.length > 0 && (
        <S.FilterRow>
          {filters.map((filter) => (
            <S.FilterButton
              key={filter.key}
              type="button"
              active={filter.active}
              disabled={disabledFilters.includes(filter.key)}
              accent={accent}
              onClick={() => onFilterClick?.(filter.key)}
            >
              <span>{filter.label}</span>
            </S.FilterButton>
          ))}
        </S.FilterRow>
      )}

      <S.List>
        {events.length > 0 ? (
          events.map((event) => (
            <EventCard key={event.id || event.codigo || event.nome} event={event} accent={accent} blinkDelay={blinkDelays.get(event)} destaqueAtraso={maisAtrasados.has(event)} mostrarMeses={mostrarMeses} onClick={(ev) => onCardClick?.(ev, columnKey)} />
          ))
        ) : (
          <S.EmptyState>
            <span>Nenhum evento</span>
          </S.EmptyState>
        )}
      </S.List>
    </S.Column>
  );
}
